import safeCreateAction from "../../../actions/safeCreateAction";
/**
 * change the mod install path. Supports placeholders
 */
export const setInstallPath = safeCreateAction("SET_MOD_INSTALL_PATH", (gameId, path) => ({ gameId, path }));
export const setInstallPathMode = safeCreateAction("SET_MOD_INSTALL_PATH_MODE", (mode) => mode);
export const setSuggestInstallPathDirectory = safeCreateAction("SET_SUGGEST_INSTALL_PATH_DIRECTORY", (path) => path);
/**
 * sets the activator to use for this game
 */
export const setActivator = safeCreateAction("SET_ACTIVATOR", (gameId, activatorId) => ({ gameId, activatorId }));
export const setShowModDropzone = safeCreateAction("SET_SHOW_MOD_DROPZONE", (show) => show);
export const setConfirmPurge = safeCreateAction("SET_CONFIRM_PURGE", (confirm) => confirm);
export const setCleanupOnDeploy = safeCreateAction("SET_CLEANUP_ON_DEPLOY", (cleanup) => cleanup);
